import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const getData = document.cookie.indexOf('isLogin=true')>-1?localStorage.getItem('userdata'):''

export default new Vuex.Store({
    state:{
        isLogin:document.cookie.indexOf('isLogin=true')>-1?true:false,
        userdata:getData?JSON.parse(getData):''
    },
    mutations:{
        setLogin(state){
            document.cookie = 'isLogin=true'
            state.isLogin = true
        },
        setUsername(state,name){
            document.cookie = 'username='+name
            state.username = name
        },
        quitLogin(state){
            state.isLogin = false;
            state.userdata = '';
            document.cookie = 'isLogin=';
            localStorage.removeItem('userdata')
        },
        setuserdata(state,data){
            state.userdata = data
            localStorage.setItem('userdata',JSON.stringify(data))
        }
    }
})


// WEBPACK FOOTER //
// ./src/store.js